/* ------------------------------------------------------------------ *
 * Variant fix — handles 250+ variant products without page reload.
 *
 * Shopify caps product.variants at 250.  Out-of-range colours have no
 * client-side data, so the theme's client-side lookup fails.
 *
 * This script:
 *   1. CAPTURE phase — predicts the new selection BEFORE the theme
 *      processes the click and hides the old price instantly.
 *   2. BUBBLE phase  — reads the real selection, fetches the correct
 *      variant via Section Rendering API, patches the DOM.
 *   3. Uses the VARIANT ID as the primary truth check — more reliable
 *      than comparing option-value strings.
 *   4. Falls back to page reload only if AJAX fails.
 * ------------------------------------------------------------------ */
(function () {
  'use strict';

  function init() {
    var section = document.querySelector('[data-product-section]');
    if (!section) return;
    if (section.dataset.useServerOptionNavigation !== 'true') return;

    var SECTION_ID  = section.dataset.sectionId;
    var PRODUCT_URL = section.dataset.productUrl || location.pathname;
    if (!SECTION_ID || !PRODUCT_URL) return;

    // Build a set of loaded variant IDs for fast lookup.
    var loaded = [];
    var loadedIdSet = {};
    var blob = section.querySelector('[data-product-json]');
    if (blob) {
      try {
        loaded = JSON.parse(blob.textContent.trim());
        loaded.forEach(function (v) { if (v.id) loadedIdSet[v.id] = true; });
      } catch (e) { /* empty */ }
    }

    function getSelected(attr) {
      var result = [];
      var byIndex = {};
      document.querySelectorAll('[data-option-value-id][data-option-index]').forEach(function (btn) {
        var idx = btn.dataset.optionIndex;
        if (!byIndex[idx]) byIndex[idx] = [];
        byIndex[idx].push(btn);
      });
      Object.keys(byIndex).forEach(function (idx) {
        var buttons = byIndex[idx];
        if (idx === '0') {
          var activePanel = document.querySelector('[data-fabric-panel].is-active');
          if (activePanel) {
            var activeBtn = activePanel.querySelector(
              '[data-option-index="0"].is-selected[data-option-value-id], ' +
              '[data-option-index="0"][aria-pressed="true"][data-option-value-id]'
            );
            if (activeBtn) { result[Number(idx)] = activeBtn.getAttribute(attr); return; }
          }
        }
        for (var i = 0; i < buttons.length; i++) {
          var btn = buttons[i];
          if (btn.classList.contains('is-selected') || btn.getAttribute('aria-pressed') === 'true') {
            if (idx === '0') {
              var panel = btn.closest('[data-fabric-panel]');
              if (panel && !panel.classList.contains('is-active')) continue;
            }
            result[Number(idx)] = btn.getAttribute(attr);
            return;
          }
        }
      });
      return result;
    }

    function isLoaded(vals) {
      if (vals.every(function (v) { return v == null; })) return true;
      return loaded.some(function (v) {
        return v.option1 === vals[0] &&
          (vals[1] == null || v.option2 === vals[1]) &&
          (vals[2] == null || v.option3 === vals[2]);
      });
    }

    // True when the variant currently in the form is outside the 250-cap.
    function variantIsUnknown() {
      var el = document.querySelector('input[name="id"]');
      if (!el || !el.value) return false;
      return !loadedIdSet[Number(el.value)];
    }

    function predictAfterClick(button) {
      var clickIndex = button.dataset.optionIndex;
      var clickValue = button.getAttribute('data-option-value');
      var predicted = getSelected('data-option-value');
      predicted[Number(clickIndex)] = clickValue;
      return predicted;
    }

    var reqToken = 0;

    // Loading spinner style.
    var style = document.createElement('style');
    style.textContent =
      '[data-vfix-loading]{position:relative;color:transparent!important}' +
      '[data-vfix-loading]::after{content:"";position:absolute;top:50%;left:0;width:18px;height:18px;' +
      'margin-top:-9px;border:2px solid rgba(167,130,95,0.25);border-top-color:var(--bronze,#a7825f);' +
      'border-radius:50%;animation:vfix-spin .7s linear infinite}' +
      '@keyframes vfix-spin{to{transform:rotate(360deg)}}';
    document.head.appendChild(style);

    function showPriceLoading() {
      document.querySelectorAll('[data-price], [data-sticky-price]').forEach(function (el) {
        el.setAttribute('data-vfix-loading', '');
      });
    }

    function hidePriceLoading() {
      document.querySelectorAll('[data-vfix-loading]').forEach(function (el) {
        el.removeAttribute('data-vfix-loading');
      });
    }

    function patchOne(sel, doc) {
      var fresh = doc.querySelector(sel);
      var live  = document.querySelector(sel);
      if (fresh && live) live.textContent = fresh.textContent;
    }

    function patchAll(sel, doc) {
      var fresh = doc.querySelectorAll(sel);
      var live  = document.querySelectorAll(sel);
      fresh.forEach(function (el, i) { if (live[i]) live[i].textContent = el.textContent; });
    }

    function applyPatch(doc, optionValues) {
      var freshId = doc.querySelector('input[name="id"]');
      var liveId  = document.querySelector('input[name="id"]');
      if (freshId && liveId && freshId.value) {
        liveId.value = freshId.value;
        liveId.dispatchEvent(new Event('input',  { bubbles: true }));
        liveId.dispatchEvent(new Event('change', { bubbles: true }));
      }

      patchAll('[data-price]', doc);
      patchAll('[data-price-save]', doc);
      patchAll('[data-compare-price]', doc);

      doc.querySelectorAll('[data-compare-wrap]').forEach(function (el, i) {
        var live = document.querySelectorAll('[data-compare-wrap]')[i];
        if (live) live.hidden = el.hidden;
      });

      // Store the base variant price from the server response so that
      // storage/service add-on price changes can use it when the variant
      // is outside the 250-variant client-side data cap.
      var freshPrice = doc.querySelector('[data-price]');
      var freshCompare = doc.querySelector('[data-compare-price]');
      if (freshPrice) {
        var priceNum = parseFloat(freshPrice.textContent.replace(/[^0-9.]/g, ''));
        if (!isNaN(priceNum)) {
          section.dataset.vfixBasePrice = String(Math.round(priceNum * 100));
        }
      }
      if (freshCompare) {
        var compareNum = parseFloat(freshCompare.textContent.replace(/[^0-9.]/g, ''));
        if (!isNaN(compareNum)) {
          section.dataset.vfixBaseComparePrice = String(Math.round(compareNum * 100));
        }
      }

      patchOne('[data-sticky-price]', doc);
      patchOne('[data-sticky-variant]', doc);

      var freshAtc = doc.querySelector('[data-add-to-cart]');
      var liveAtc  = document.querySelector('[data-add-to-cart]');
      if (freshAtc && liveAtc) {
        liveAtc.disabled = freshAtc.disabled;
        var fm = freshAtc.querySelector('[data-atc-main]');
        var lm = liveAtc.querySelector('[data-atc-main]');
        if (fm && lm) lm.textContent = fm.textContent;
      }

      var fsa = doc.querySelector('[data-sticky-atc-submit]');
      var lsa = document.querySelector('[data-sticky-atc-submit]');
      if (fsa && lsa) lsa.disabled = fsa.disabled;

      try {
        var u = new URL(window.location.href);
        u.searchParams.delete('variant');
        u.searchParams.set('option_values', optionValues);
        window.history.replaceState({}, '', u.toString());
      } catch (e) { /* ignore */ }
    }

    function syncBuyBox() {
      var vals = getSelected('data-option-value');
      var ids  = getSelected('data-option-value-id');

      var optionValues = ids.filter(Boolean).join(',');
      if (!optionValues) { hidePriceLoading(); return; }

      // In-range AND variant ID is known → theme handles it, nothing to do.
      if (isLoaded(vals) && !variantIsUnknown()) {
        hidePriceLoading();
        return;
      }

      // Out-of-range or unknown variant — fetch correct data from server.
      var myToken = ++reqToken;
      var url = PRODUCT_URL + '?sections=' + SECTION_ID + '&option_values=' + optionValues;

      fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (res) {
          if (!res.ok) throw new Error('Section render failed: ' + res.status);
          return res.json();
        })
        .then(function (payload) {
          if (myToken !== reqToken) return;
          var html = (payload && typeof payload === 'object') ? payload[SECTION_ID] : '';
          if (!html) throw new Error('Empty response');
          var doc = new DOMParser().parseFromString(html, 'text/html');
          applyPatch(doc, optionValues);
          hidePriceLoading();
        })
        .catch(function () {
          hidePriceLoading();
          if (myToken === reqToken) {
            window.location.assign(PRODUCT_URL + '?option_values=' + optionValues);
          }
        });
    }

    // ── CAPTURE PHASE ──────────────────────────────────────────────────
    // Runs BEFORE the theme's click handler.
    // Predicts whether the new selection will be out-of-range
    // and hides the old price instantly.
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-option-value-id]');
      if (!btn) return;
      var predicted = predictAfterClick(btn);
      if (!isLoaded(predicted)) {
        showPriceLoading();
      }
    }, true);

    // ── BUBBLE PHASE ───────────────────────────────────────────────────
    // Runs AFTER the theme has set .is-selected.
    // Reads the real selection and fetches if needed.
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-option-value-id]')) {
        setTimeout(syncBuyBox, 50);
      }
    });

    // ── MUTATION OBSERVER ──────────────────────────────────────────────
    // After the theme replaces the section via renderSectionForSelection,
    // re-check: if the new section still has an out-of-range variant, patch it.
    var sectionParent = section.parentElement;
    if (sectionParent) {
      var moTimer = null;
      new MutationObserver(function () {
        clearTimeout(moTimer);
        moTimer = setTimeout(function () {
          var cur = document.querySelector('input[name="id"]');
          if (!cur || !cur.value) return;
          // If the section was replaced and the variant is still unknown, patch.
          if (variantIsUnknown()) {
            var ids = getSelected('data-option-value-id');
            var optionValues = ids.filter(Boolean).join(',');
            if (optionValues) {
              var url = PRODUCT_URL + '?sections=' + SECTION_ID + '&option_values=' + optionValues;
              var myToken = ++reqToken;
              fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
                .then(function (res) { if (!res.ok) throw new Error('fail'); return res.json(); })
                .then(function (payload) {
                  if (myToken !== reqToken) return;
                  var html = (payload && typeof payload === 'object') ? payload[SECTION_ID] : '';
                  if (!html) return;
                  applyPatch(new DOMParser().parseFromString(html, 'text/html'), optionValues);
                  hidePriceLoading();
                })
                .catch(function () { hidePriceLoading(); });
            }
          }
        }, 300);
      }).observe(sectionParent, { childList: true, subtree: false });
    }

    console.info('[variant-fix] active —', loaded.length, 'variants loaded;');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
